import { useInstance, createRef } from 'intact-react';
import { isNullOrUndefined, EMPTY_OBJ } from 'intact-shared';
import { findChildren, isComponentVNode } from '../utils';
import { Option } from './option';
import { OptionGroup } from './group';
import { useBaseLabel } from './useBaseLabel';
export function useLabel() {
  var instance = useInstance();
  var activeIndices = createRef([]);
  var _useBaseLabel = useBaseLabel(function () {
      return instance.get('children');
    }, findLabel),
    getLabel = _useBaseLabel.getLabel;
  function findLabel(children, value) {
    var label = null;
    var index = 0;
    activeIndices.value = [];
    var loop = function loop(children) {
      return findChildren(children, function (vNode) {
        if (isComponentVNode(vNode, Option)) {
          var props = vNode.props;
          if (isNullOrUndefined(props)) return false;
          if (props.value === value) {
            label = props.label;
            if (isNullOrUndefined(label)) {
              label = props.children;
            }
            return true;
          }
        } else if (isComponentVNode(vNode, OptionGroup)) {
          if (loop((vNode.props || EMPTY_OBJ).children)) {
            activeIndices.value.push(index);
            return true;
          }
          index++;
        }
        return false;
      });
    };
    loop(children);
    return label;
  }
  return {
    getLabel: getLabel,
    activeIndices: activeIndices
  };
}